var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMxc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m24.18 3.53-8.873 15.368c-.08.14-.15.286-.207.435L8.81 9.041h-5.81v20.96h6.438v-9.222l4.55 7.336h3.115l4.55-7.665.061 9.55h6.437L28.093 9.04h-.03L29.48 6.59a3.057 3.057 0 0 0-2.252-4.562A3.058 3.058 0 0 0 24.18 3.53z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMxc);
export default __webpack_public_path__ + "static/media/MXC.e9040029d9ce24bf653fc584379638e2.svg";
export { ForwardRef as ReactComponent };